import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NzButtonModule } from 'ng-zorro-antd/button';

/** Shown when a route's `PermissionGuard` finds the user lacks the permission it asks for. */
@Component({
  selector: 'gains-no-access-screen',
  standalone: true,
  imports: [AngularSvgIconModule, NzButtonModule],
  templateUrl: './no-access-screen.component.html',
  styleUrl: '../not-found-screen/not-found-screen.component.scss'
})
export class NoAccessScreenComponent {
  constructor(
    private readonly _router: Router,
    private readonly _location: Location
  ) {}

  goBack(): void {
    this._location.back();
  }

  goHome(): void {
    this._router.navigate(['/home']);
  }
}
